import useSelectedCompany from '../../hooks/useSelectedCompany';
import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import { CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME } from '../../theme/constants/toolbar';
import NationalTaxServiceCredentialsDialog from '../dialogs/NationalTaxServiceCredentialDialog';
import { nationalTaxServiceCredentialsDialogVar } from '../../apollo/reactive-variables/alerts';

const cellCentered = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const CredentialsUpdateFooter = ({ children, source }) => {
  const company = useSelectedCompany();
  const handleOpenCredentialsDialog = () => {
    nationalTaxServiceCredentialsDialogVar({
      open: true,
      autocomplete: true,
      showTerms: !company?.hasLendingAcceptedterms,
      source: source,
    });
  };
  return (
    <>
      <Toolbar className={CREDENTIALS_UPDATE_BOTTOM_BAR_CLASS_NAME}>
        <Grid container alignItems="center" style={{ width: '100%' }}>
          <Grid item xs={3} style={cellCentered}>
          </Grid>
          <Grid item xs={6} style={cellCentered}>
            <Typography variant="medium_1" color="white" align="center" sx={{ fontWeight: 'bold' }}>
              Detectamos que actualizaste tus credenciales del SII. Debes actualizarlas aquí para poder
              evaluar tus facturas.
            </Typography>
          </Grid>
          <Grid item xs={3} style={cellCentered}>
            <Button variant="secondary" color="primary" size="small" type="button" onClick={handleOpenCredentialsDialog}>
              <Typography variant="small_2" fontWeight={700} component="span">
                Actualizar clave
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </Toolbar>

      <NationalTaxServiceCredentialsDialog source={source} />
    </>
  );
};
CredentialsUpdateFooter.propTypes = {
  children: PropTypes.node,
  source: PropTypes.string,
};

CredentialsUpdateFooter.defaultProps = {
  children: null,
  source: null,
};

export default CredentialsUpdateFooter;